import { SearchOutlined } from '@ant-design/icons';
import { Col, Flex, Form, Grid, Input, Row, Typography } from 'antd';
import axios from 'axios';
import * as React from 'react';
import { memo, useContext, useEffect } from 'react';
import { useSearch } from '../hooks/use-search';
import { localize } from '/react4xp/mixins/helpers';
import Button from '/react4xp/mixins/ui/button/button';
import { ComponentContext } from '/react4xp/parts/knowledge-base/knowledge-base';

const { useBreakpoint } = Grid;

type SearchBarProps = ReturnType<typeof useSearch>;

const SearchBar = memo(({ isLoading, search, results, clear, form }: SearchBarProps) => {
    const { translations, commonTranslations } = useContext(ComponentContext);
    const { md } = useBreakpoint();

    const [popularQueries, setPopularQueries] = React.useState([]);

    useEffect(() => {
        axios.get('/_/service/isnareactcms/kb-top-viewed-articles').then((res) => {
            const queries = res.data?.map(({ title }) => title);
            setPopularQueries(queries);
        });
    }, []);

    const onQueryClick = (query: string) => {
        form.setFieldsValue({ query });
        search({ query });
    };

    return (
        <Form
            form={form}
            onFinish={search}
            layout="inline"
            className="search-form"
        >
            <Row
                gutter={[10, 10]}
                style={{
                    flexGrow: 1,
                }}
            >
                <Col
                    xs={24}
                    md={6}
                >
                    <label className="title">{localize('label.search', translations)}</label>
                </Col>

                <Col
                    xs={24}
                    md={18}
                    xl={12}
                >
                    <Flex vertical>
                        <Form.Item
                            colon={false}
                            name="query"
                            style={{
                                margin: 0,
                            }}
                        >
                            <Input
                                prefix={<SearchOutlined style={{ color: 'gray' }} />}
                                placeholder={localize('placeholder.search', translations)}
                                allowClear
                            />
                        </Form.Item>
                        <Typography.Text
                            style={{
                                color: '#999999',
                            }}
                        >
                            {localize('popular-requests', translations)}{' '}
                            {popularQueries.map((query, index) => (
                                <button
                                    onClick={() => onQueryClick(query)}
                                    className="popular_query_button"
                                    type="button"
                                >
                                    {query}
                                    {index === popularQueries.length - 1 ? '' : ', '}
                                </button>
                            ))}
                        </Typography.Text>
                    </Flex>
                </Col>

                <Col
                    xs={24}
                    md={12}
                    xl={3}
                >
                    {md && (
                        <Button
                            htmlType="submit"
                            block
                            loading={isLoading}
                            type="primary"
                            style={{
                                width: '100%',
                            }}
                        >
                            {localize('button.find', commonTranslations)}
                        </Button>
                    )}
                </Col>

                <Col
                    xs={24}
                    md={12}
                    xl={3}
                >
                    {results && (
                        <Button
                            onClick={() => clear()}
                            style={{ width: '100%' }}
                        >
                            {localize('button.reset', commonTranslations)}
                        </Button>
                    )}
                </Col>
            </Row>
        </Form>
    );
});

export default SearchBar;
